import { CreditApplication } from '../transactions/transaction.model';
export interface InvoiceAttachmentEntry {
  filename: string;
  mimeType: string;
  base64: string;
  extractedFields?: any;
}

export interface InvoiceDetailsInterface {
  invoiceNumber?: string;
  invoiceTotalAmount?: number;
  taxAmount?: number;
  shippingAmount?: number;
  capitalAmount?: number;
  totalAmount?: number;
  enablePreauth?: boolean;
  isMultiInvoiceMode?: boolean;
  multiInvoiceData?: MultiInvoiceCheckoutData;
  /** Uploaded invoice files to be attached to the FlashPay request */
  attachments?: InvoiceAttachmentEntry[];
}

// Multi-invoice checkout models
export interface InvoiceCheckoutItem {
  invoice: any; // InvoiceModel from customer.model.ts
  /** Everything paid on this invoice — credit applied plus cash (editable, up to outstanding). */
  paymentAmount: number;
  outstandingBalance: number; // Total outstanding on invoice
  /** The part of `paymentAmount` covered by credit memos. Absent (0) when none applied. */
  creditAmount?: number;
  /** The part of `paymentAmount` the charge covers: `paymentAmount − creditAmount`. */
  cashAmount?: number;
}

export interface MultiInvoiceCheckoutData {
  invoices: InvoiceCheckoutItem[];
  /** What will be charged: invoice cash + on-account amount + capital cost. */
  totalAmount: number;
  customerId: string;
  customerName: string;
  capitalCostEnabled?: boolean;
  capitalCostPercent?: number;
  capitalCostAmount?: number;
  /** Credit memo → invoice pairings, largest invoice first. */
  creditApplications?: CreditApplication[];
  /** Σ creditApplications. */
  creditsAppliedAmount?: number;
  /** Paid onto the account rather than an invoice (profile's allowPaymentToAccount). */
  onAccountAmount?: number;
  /** Cash before capital cost: invoice cash + on-account amount. */
  cashSubtotal?: number;
  /**
   * The single payment amount the operator entered, when they did: it was spread over the
   * selected invoices oldest due first, the rest on account. Absent when amounts were set
   * per invoice.
   */
  paymentTotal?: number | null;
  /** Why the selection cannot be submitted, or null — gates the wizard's Next. */
  validationError?: string | null;
}

export enum PaymentType {
  SALE = 'sale',
  PREAUTH = 'preauth',
  COMPLETE_AUTH = 'completeAuth',
  REFUND = 'refund',
  FLASHPAY = 'flashpay',
  ADJUST = 'adjust',
}

export interface ValidateCardRequest {
  paymentAccount?: PaymentAccount;
  encryptedPaymentAccount?: string;
}

export interface PaymentAccount {
  requestType: 'ACH' | 'CARD' | 'CARDSWIPE';
  account?: string;
  cardHolderName?: string;
  expirationDate?: string;
  streetAddress?: string;
  zipCode?: string;
  cvv?: string;
  accountType?: string;
  abaRoute?: string;
  accountHolderName?: string;
  cardTrackData?: string;
  ignoreCVV?: boolean;
  ignoreZip?: boolean;
  ignoreStreet?: boolean;
}
